<div class="timeline">
  <div *ngIf="items.length != 0" class="ui-g">
    <div *ngFor="let item of items" class="ui-g-12">
      <i class="material-icons {{ iconMapping[item.historyType] }}"></i>
      <span class="event-owner">{{ item.header }}</span
      ><span class="event-time">{{ item.time | datex : 'ddd DD MMM HH:mm' }}</span>
      <div class="event-content">
        {{ item.content }}
      </div>
    </div>
  </div>

  <div *ngIf="items.length == 0" class="ui-g">
    <div style="margin: 10px">{{ emptyMessage }}</div>
  </div>
</div>
